import { render, staticRenderFns } from "./TicketTagConfig.vue?vue&type=template&id=d04d842c"
import script from "./TicketTagConfig.vue?vue&type=script&lang=js"
export * from "./TicketTagConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports